export default __webpack_public_path__ + "static/media/neha.0a6f02cd.jpeg";